document.addEventListener('DOMContentLoaded', function () {
  initClickAttribute()
  closeCardCompares()
  initAnimatedSvg()
  // inputMaskCustom() // disabled — conflicts with IMask (initInputmask)
  initLogin()
  openAuth()

  initinterregional()

  initMainNav()
  initSwiper()
  initFancyBox()
  initBasket()
  initTabs()
  initFormValidation()
  initPlaceholder()
  initTextOverflowHidden()
  initAnimationCounter()
  initMenu()
  initMainCatalog()
  initDropDown()
  initOpenCloseCard()
  initCardBuy()
  initAccordionSlider()
  initAddModifation()
  initProductFilter()
  initProfile()
  initDragDrop()
  initInputEye()
  initPopupsClearDN()
  popupCheck()
  initRangeSlider()
  initMgBurger()
  mgSlideUpDown()

  // yMap()
  validationSocial()
  mgCategory()
  reff()

  lazyLoadImg()

  initPulseCardProduct()

  closePopup()


  // initBonusRange()

  // initBonusStatistick()

  // showCallbackFrom()






  // rating()
  // initOpenClose();
  // initActiveSelectResize()
  // mgCrop();
  // toggleAccordion();
  // initCounter();
  // initSelectCity();
  // initSearch();
  //mgAnchor();
  // popupSlide();
  // popupSelect();
  // popupCounter();
  // popupTotal();
  // document.querySelectorAll("[style='display: none']").forEach(el => el.removeAttribute('style'))

  $.fancybox.defaults.btnTpl.share = false
})

